const actions = {
  SET_LANGUAGE: 'SET_LANGUAGE',
  RESET_LANGUAGE: 'RESET_LANGUAGE',

  setLanguage: (language) => ({
    type: actions.SET_LANGUAGE,
    language,
  }),

  resetLanguage: () => ({
    type: actions.RESET_LANGUAGE,
  }),
};

export default actions;
